import { getCurrentPath } from "@faire/web--source/common/Path";
export var isMobileApp = function() {
    return getCurrentPath().searchParams.get("native_env") === "true";
};
